import {createContext, use} from 'react'

import type {CommitsLayoutPayload} from '../routes/commits-layout-route'

/** Provided by the data router layout route, or by `App` from the app payload on the legacy app. */
export const CommitsLayoutPayloadContext = createContext<CommitsLayoutPayload>({
  helpUrl: '',
})

export function useCommitsAppPayload(): CommitsLayoutPayload {
  return use(CommitsLayoutPayloadContext)
}
